









































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { getOperationID, getOperation } from '@/api/operations'
import Alert from '@/components/Alert.vue'
import { getBoUrl } from '@/api/http-constants'
import store from '@/store'
import get from 'lodash/get'
import router from '@/router'

interface IUser {
    email: string
    plainPassword: string
}

enum IRelationType {
    Familly = 'Familly',
    Friend = 'Friend',
    Animal = 'Animal',
}

interface IMember {
    id: number
    firstname: string
    relationType: IRelationType
    age: string
    sex?: string
    petType?: string
}

interface IFoyer {
    hobbies: number[]
    sharedSpaces: number[]
    members: IMember[]
    identiKits: number[]
    description: string
}

@Component({
    components: {
        SmoothReflow,
        Alert,
    },
    filters: {
        substr(value) {
            return value.substr(0, 1)
        },
        traduction(value) {
            switch (value) {
                case 'Friend':
                    return 'Ami'
                case 'Familly':
                    return 'Famille'
                case 'Animal':
                    return 'Animal'
            }
        },
    },
})
export default class Foyer extends Vue {
    apiService = new ApiService()
    userID: number = null
    submitted: boolean = false
    placeholders = {
        description: `Je suis papa de deux enfants, graphiste de profession et grand amateur de cinéma d'art et d'essais.
J'aime le calme la semaine et passer des week-end plus animés.
Je suis bricoleur et j'ai la main verte. J'apprécierais donc d'avoir à disposition un atelier de bricolage et un jardin pour mettre en commun des moyens et partager de bons moments`,
    }
    settings = {
        copyClassesToDropdown: false,
        plugins: {
            remove_button: {
                title: 'Enlever',
                label: '<i class="fa fa-times-circle"></i>',
                className: 'selectize-remove-button',
            },
        },
        /**
         * On s'assure que la classe active est bien supprimée lors de l'ajout
         * d'un item.
         */
        onItemAdd: (value, $item) => {
            const item = $item.get()[0]
            item.classList.remove('active')
        },
        /**
         * Fix la non suppression du hightlight
         */
        onType: function(str) {
            if (str === '') {
                this.$dropdown_content.removeHighlight()
            }
        },
        onFocus: function(str) {
            requestAnimationFrame(() => {
                this.$dropdown_content.removeHighlight()
            })
        },
    }
    maxSettings = {
        ...this.settings,
        maxItems: 3,
    }

    maxSettingsTo5 = {
        ...this.settings,
        maxItems: 5,
    }

    id: number = null
    opeID: number = null
    userOpeID: number = null
    foyer: IFoyer = {
        hobbies: [],
        sharedSpaces: [],
        members: [],
        identiKits: [],
        description: '',
    }

    identiKits = []
    hobbies = []
    categories = []
    spaces = []

    async created() {
        await UserModule.Init()
        this.userID = UserModule.userInfos.id
        this.id = UserModule.userInfos.id
        this.opeID = await getOperationID()

        /**
         * Récupération des définitions
         */
        this.apiService.getHobbies().then(resp => {
            this.hobbies = resp.data
        })

        this.apiService.getCategories().then(resp => {
            this.categories = resp.data
        })

        this.apiService.getSharedSpaces().then(resp => {
            this.spaces = resp.data
        })

        this.apiService.getIdentiKits().then(resp => {
            this.identiKits = resp.data
        })

        /**
         * Récupératoon des hobbies
         */
        this.apiService.getBuyer(this.id).then(resp => {
            const hobbies = resp.data.hobbies
            const hobbiesID = hobbies.map(el => {
                return el.id
            })
            this.foyer.hobbies = hobbiesID
            this.foyer.description = resp.data.comment
        })

        /**
         * Récupération de l'UserOperation
         */
        this.apiService.getUserOperation(this.id, this.opeID).then(resp2 => {
            const userOperation = resp2.data
            console.log(userOperation)
            this.userOpeID = userOperation.id

            const sharedSpacesId = userOperation.sharedSpaces.map(el => {
                return el.id
            })
            const identiKitsId = userOperation.identikits.map(el => {
                return el.id
            })
            let users = []
            userOperation.familyMembers.forEach(el => {
                users.push({
                    id: el.id,
                    firstname: el.name,
                    age: el.age,
                    relationType: el.type,
                })
            })

            this.foyer.sharedSpaces = sharedSpacesId
            this.foyer.identiKits = identiKitsId
            this.foyer.members = users
        })
    }

    get hobbiesValid(): boolean {
        return this.foyer.hobbies.length > 0
    }

    get sharedSpacesValid(): boolean {
        return this.foyer.sharedSpaces.length > 0
    }

    get identiKitsValid(): boolean {
        return this.foyer.identiKits.length > 0
    }

    get foyerValid(): boolean {
        return (
            this.hobbiesValid &&
            this.sharedSpacesValid &&
            this.identiKitsValid
        )
    }

    get hobbiesByCategory() {
        if (!this.hobbies || this.hobbies.length === 0) return [];

        // Grouper les hobbies par catégorie
        const grouped = this.hobbies.reduce((acc, hobby: any) => {
            // CORRECTION ICI : On vérifie si hobby.category existe avant de demander le nom
            const categoryName = (hobby.category && hobby.category.name) ? hobby.category.name : 'Autres';

            if (!acc[categoryName]) {
                acc[categoryName] = []
            }
            acc[categoryName].push(hobby)
            return acc
        }, {})

        // Trier les catégories par ordre alphabétique
        const sortedCategories = Object.keys(grouped).sort((a, b) =>
            a.localeCompare(b, 'fr')
        )

        // Créer un tableau ordonné
        return sortedCategories.map(category => ({
            name: category,
            hobbies: grouped[category]
        }))
    }

    async handleSubmit(e) {
        e.preventDefault()
        console.log({ ...this.foyer })

        if (!this.foyerValid) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'Votre profil est incomplet'
            )
            this.submitted = true
            return
        }

        this.submitted = false

        const resp = await this.apiService.patchBuyerFoyer(
            this.userOpeID,
            this.foyer
        )
        ;(<Alert>this.$refs.alert).handleAlert(
            'success',
            'Enregistrement effectué'
        )

        if (UserModule.foyerCompleted === false) {
            UserModule.markFoyerAsCompleted()
            router.push({ name: 'funnel-appart' })
        }
    }

    /**
     * Gestion des membres
     */
    selected_member: IMember = null
    new_member: IMember = {
        id: null,
        age: null,
        sex: null,
        firstname: null,
        relationType: IRelationType.Familly,
        petType: null,
    }
    selectizeResetKey: number = 0

    mounted() {
        ;(<any>$(this.$refs.editMemberModal)).on(
            'hidden.bs.modal',
            this.cleanUpNewMember
        )
        ;(<any>$(this.$refs.hobbiesModal)).on(
            'hidden.bs.modal',
            this.cleanUpNewHobby
        )
        ;(<any>$(this.$refs.espacesModal)).on(
            'hidden.bs.modal',
            this.cleanUpNewSpace
        )
        ;(<any>$(this.$refs.visionModal)).on(
            'hidden.bs.modal',
            this.cleanUpNewVision
        )
        this.$watch('new_member.relationType', (newVal) => {
            if (newVal === IRelationType.Animal) {
                this.new_member.sex = null
                this.new_member.age = null
            } else {
                this.new_member.petType = null
            }
            this.selectizeResetKey = this.selectizeResetKey + 1
        })

        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }
    destroyed() {
        ;(<any>$(this.$refs.editMemberModal)).off(
            'hidden.bs.modal',
            this.cleanUpNewMember
        )
        ;(<any>$(this.$refs.hobbiesModal)).off(
            'hidden.bs.modal',
            this.cleanUpNewHobby
        )
        ;(<any>$(this.$refs.espacesModal)).off(
            'hidden.bs.modal',
            this.cleanUpNewSpace
        )
        ;(<any>$(this.$refs.visionModal)).off(
            'hidden.bs.modal',
            this.cleanUpNewVision
        )
    }

    showAddMemberForm(member?) {
        ;(<any>$(this.$refs.editMemberModal)).modal('show')
        if (member) {
            this.selected_member = member
            this.new_member = { ...member }
        }
    }

    handleNewMember(e) {
        e.preventDefault()
        if (this.selected_member) {
            this.selected_member.firstname = this.new_member.firstname
            this.selected_member.relationType = this.new_member.relationType
            this.selected_member.age = this.new_member.age
            this.selected_member.sex = this.new_member.sex
            this.selected_member.petType = this.new_member.petType
        } else {
            // push a shallow copy to avoid reusing the same object reference
            this.foyer.members.push({ ...this.new_member })
            console.log(this.new_member)
        }
        ;(<any>$(this.$refs.editMemberModal)).modal('hide')
    }

    removeMember(member) {
        const index = this.foyer.members.indexOf(member)
        this.foyer.members.splice(index, 1)
    }

    cleanUpNewMember() {
        this.selected_member = null
        this.new_member = {
            id: null,
            age: null,
            sex: null,
            firstname: null,
            relationType: IRelationType.Familly,
            petType: null,
        }
    }

    /**
     * Utile pour le transition-group
     */
    lastUids = new Map()
    get uids() {
        let uids = new Map()
        for (const key in this.foyer.members) {
            const member = this.foyer.members[key]
            var uid = this.lastUids.get(member)
            if (!uid) {
                uid = this.guid()
            }
            uids.set(member, uid)
        }
        this.lastUids = uids
        return uids
    }

    uid(member) {
        return this.uids.get(member)
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1)
        }
        return (
            s4() +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            s4() +
            s4()
        )
    }

    new_hobby = {
        name: '',
        category: '',
    }
    new_space = {
        name: '',
        category: '',
    }
    new_vision = {
        name: '',
    }

    async handleNewHobby(e) {
        e.preventDefault()

        await this.$nextTick()

        if (!this.new_hobby.category.length || !this.new_hobby.name.length) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'Vous devez obligatoirement renseigner une catégorie et un nom'
            )
            return
        }

        ;(<any>$('#hobbiesModal')).modal('hide')

        try {
            const response = await this.apiService.postHobbySuggest(
                this.new_hobby
            )
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                response.data.message
            )
            const fullName = `${UserModule.userInfos.firstname} ${UserModule.userInfos.lastname}`.trim()
            this.apiService.postAdminNotification({
                type: 'suggestion',
                message: `${fullName} a suggéré un nouveau hobby : « ${this.new_hobby.name} ».`.substring(0, 255),
                context: { user_id: this.userID },
            }).catch(() => { /* silent */ })
        } catch (e) {
            const message = get(
                e,
                'data.errors.children.name.errors[0]',
                get(e, 'data.message', 'Une erreur est survenue')
            )
            ;(<Alert>this.$refs.alert).handleAlert('danger', message)
        }
    }

    async handleNewSpace(e) {
        e.preventDefault()

        await this.$nextTick()

        if (!this.new_space.name.length) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'Vous devez obligatoirement renseigner un nom'
            )
            return
        }

        ;(<any>$('#espacesModal')).modal('hide')

        try {
            const response = await this.apiService.postSpaceSuggest(
                this.new_space
            )
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                response.data.message
            )
            const fullName = `${UserModule.userInfos.firstname} ${UserModule.userInfos.lastname}`.trim()
            this.apiService.postAdminNotification({
                type: 'suggestion',
                message: `${fullName} a suggéré un espace partagé : « ${this.new_space.name} ».`.substring(0, 255),
                context: { user_id: this.userID },
            }).catch(() => { /* silent */ })
        } catch (e) {
            const message = get(
                e,
                'data.errors.children.name.errors[0]',
                get(e, 'data.message', 'Une erreur est survenue')
            )
            ;(<Alert>this.$refs.alert).handleAlert('danger', message)
        }
    }

    async handleNewVision(e) {
        e.preventDefault()

        await this.$nextTick()

        if (!this.new_vision.name.length) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'Vous devez obligatoirement renseigner un nom'
            )
            return
        }

        ;(<any>$('#visionModal')).modal('hide')

        try {
            const response = await this.apiService.postIdentiKitSuggest(
                this.new_vision
            )
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                response.data.message
            )
            const fullName = `${UserModule.userInfos.firstname} ${UserModule.userInfos.lastname}`.trim()
            this.apiService.postAdminNotification({
                type: 'suggestion',
                message: `${fullName} a suggéré un IdentKit : « ${this.new_vision.name} ».`.substring(0, 255),
                context: { user_id: this.userID },
            }).catch(() => { /* silent */ })
        } catch (e) {
            const message = get(
                e,
                'data.errors.children.name.errors[0]',
                get(e, 'data.message', 'Une erreur est survenue')
            )
            ;(<Alert>this.$refs.alert).handleAlert('danger', message)
        }
    }

    cleanUpNewHobby() {
        this.new_hobby = {
            name: '',
            category: '',
        }
    }

    cleanUpNewSpace() {
        this.new_space = {
            name: '',
            category: '',
        }
    }

    cleanUpNewVision() {
        this.new_vision = {
            name: '',
        }
    }
}
